import Base64 from './base64lib';

class FeatureFlagResolver {
  constructor() {
    this.features = {};
  }

  /**
	 * Checks internal features property and ensures that a specific feature is enabled
	 * @param {*} featureFlagKey The key of the feature flag to be checked
	 * @param {*} stagingFlag Optional staging flag parameter
	 * @returns true if the feature flag is enabled , false if not enabled or if the key doesn't exist in the internal cache
	 */
  isEnabled(featureFlagKey) {
    const encodedKey = Base64.encode(featureFlagKey);
    return this.features[encodedKey] || false;
  }

  /**
	 * Clears the featureflagResolver's internal feature flag cache
	 */
  clearFeatureFlags() {
    this.features = {};
  }

  /**
	 * Set the featureFlagResolvers' internal cache
	 * @param {*} features Object containing feature flag data
	 */
  setFeatureFlags(features) {
    this.features = features;
  }

  /**
	 *
	 * @returns Internal feature flag object of the featureFlagResolver
	 */
  getFeatureFlags() {
    return this.features;
  }

  /**
	 * Set the featureFlagResolvers' internal cache
	 * @param {*} features Object containing feature flag data
	 */
  hasFeatureFlags() {
    return Object.keys(this.features).length > 0;
  }

}

/*eslnit-disable*/
const instance = new FeatureFlagResolver();
export default instance;
